module.exports = __webpack_public_path__ + "assets/img/info.1459403c.svg";